import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadImage } from "@/lib/db";

export function ImageUpload({ value, onChange, testid }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const url = await uploadImage(file);
      onChange(url);
      toast.success("Η εικόνα ανέβηκε");
    } catch (err) {
      toast.error(`Αποτυχία μεταφόρτωσης: ${err?.message || "άγνωστο σφάλμα"}`);
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      <div className="grid h-16 w-16 shrink-0 place-items-center overflow-hidden rounded-lg border border-white/15 bg-royal/40">
        {value ? (
          <img src={value} alt="preview" className="h-full w-full object-cover" />
        ) : (
          <span className="text-xs text-ice/40">—</span>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <input ref={inputRef} type="file" accept="image/*" onChange={handle} className="hidden" data-testid={testid} />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-lg border border-white/20 px-3 py-2 text-sm font-600 text-ice transition-colors hover:border-gold hover:text-gold disabled:opacity-60"
        >
          {loading ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}
          {loading ? "Ανέβασμα..." : "Ανέβασμα εικόνας"}
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-1 text-xs text-red-400 hover:text-red-300">
            <X size={12} /> Αφαίρεση
          </button>
        )}
      </div>
    </div>
  );
}
